module.exports = __webpack_public_path__ + "static/media/alara.a22a285a.png";